import React from 'react';
import TradeHistory from './TradeHistory';

export const TradeHistoryContainer: React.FC = () => {
  return <TradeHistory />;
};

export default TradeHistoryContainer;